import { createFileRoute, notFound, redirect } from "@tanstack/react-router";
import FranchiseStateLanding from "@/pages/FranchiseStateLanding";
import { STATE_BY_CODE } from "@/data/franchiseStates";
import { pageHead, unavailableHead } from "@/lib/seoPolicy";
import NotFound from "@/pages/NotFound";

export const Route = createFileRoute("/_public/franchise/$state")({
  beforeLoad: ({ params }) => {
    const code = params.state.toUpperCase();
    if (code === "WA") throw redirect({ to: "/franchise/washington", statusCode: 301 });
    if (!STATE_BY_CODE[code]) throw notFound();
    if (params.state !== params.state.toLowerCase()) throw redirect({ to: "/franchise/$state", params: { state: params.state.toLowerCase() }, statusCode: 301 });
  },
  head: ({ params }) => {
    const info = STATE_BY_CODE[params.state.toUpperCase()];
    return info ? pageHead(`${info.name} Fence Franchise — Territory Open | Modern Fence Install`, `${info.name} is open for a Modern Fence Install franchise. $10k–$20k all-in including first-job materials. Add $100k–$200k to your service business.`, `/franchise/${params.state.toLowerCase()}`, true) : unavailableHead();
  },
  notFoundComponent: NotFound,
  component: FranchiseStateLanding,
});
